import { ModelType, Type, Activity } from "../../middleware/Constants/ApplicationTypes";
import { faCog, faUserCircle, faDesktop, faMicrochip, faMobile, faServer, faGlobe } from "@fortawesome/free-solid-svg-icons";


export { APPLICATION_PATH, APPLICATIONS_PATH, CREATE_PATH, EDIT_PATH, STATISTICS_PATH, SANDBOX_PATH, ErrorMessageDisplayTimeout } from "./GlobalConstant"
export { Env, State, ModelType, Type, Activity, OauthRedirectUris_MaxValue, IosCertificateType } from "../../middleware/Constants/ApplicationTypes";;
export { SEARCH_START_TIME } from "./SearchConstant";

export const ApplicationTagName = "appId";
export const ApplicationSearchTagName = "application_search_value";
export const ApplicationFilterTagName = "application_filter_value";
export const ApplicationSandBoxTagName = "sandBoxApplication";
export const DisplaySearchAndFilterCount = 10;

export const ModelTypeLabel = {
    [ModelType.Internal]: "Internal application",
    [ModelType.Business]: "Business application",
    [ModelType.PayAsYouGo]: "Pay-as-you-go application",
    [ModelType.RainbowStore]: "Rainbow-store application",
    [ModelType.Demo]: "Other application",
}

export const TypeLabel = {
    [Type.Admin]: {
        "icon": faCog,
        "label": "Admin application"
    },
    [Type.Bot]: {
        "icon": faUserCircle,
        "label": "Bot application"
    },
    [Type.Desktop]: {
        "icon": faDesktop,
        "label": "Desktop application"
    },
    [Type.Iot]: {
        "icon": faMicrochip,
        "label": "IoT application"
    },
    [Type.Mobile]: {
        "icon": faMobile,
        "label": "Mobile application"
    },
    [Type.Server]: {
        "icon": faServer,
        "label": "Server application"
    },
    [Type.Web]: {
        "icon": faGlobe,
        "label": "Web application"
    }
};

export const ActivityLabel = {
    [Activity.A]: "agriculture",
    [Activity.B]: "mining",
    [Activity.C]: "manufacturing",
    [Activity.D]: "electricity",
    [Activity.E]: "water supply",
    [Activity.F]: "construction",
    [Activity.G]: "wholesale",
    [Activity.H]: "transportation",
    [Activity.I]: "accommodation",
    [Activity.J]: "information and communication",
    [Activity.K]: "financial",
    [Activity.L]: "real estate activities",
    [Activity.M]: "professional",
    [Activity.N]: "administrative",
    [Activity.O]: "public administration",
    [Activity.P]: "education",
    [Activity.Q]: "human heath",
    [Activity.R]: "arts",
    [Activity.S]: "other service activities",
    [Activity.T]: "activities of households as employer",
    [Activity.U]: "activities of extraterritorial organizations and bodies"
};

export const dataFieldName = {
    id: "id",
    name: "name",
    ownerName: "ownerName",
    ownerId: "ownerId",
    ownerCompany: "ownerCompany",
    kpi: "kpi",
    envOrState: "envOrState",
    dateOfCreation: "dateOfCreation",
    actions: "actions"
};
